var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loading-container', _vm.loading ? 'loading' : '']},[(_vm.loading)?_c('div',{staticClass:"loader-blur"}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }